var map = {
	"./2xcapital/logo.svg": "6ab3",
	"./abrafescdigital/logo.svg": "786e",
	"./agcontadigital/logo.svg": "c15b",
	"./ajout/logo.svg": "4496",
	"./alphataurus/logo.svg": "ff6c",
	"./areab/logo.svg": "f887",
	"./axelx/logo.svg": "6ee1",
	"./banicred/logo.svg": "9dd8",
	"./banminas/logo.svg": "8bef",
	"./banpar/logo.svg": "0aca",
	"./bantdigital/logo.svg": "d994",
	"./boavistapay/logo.svg": "65e1",
	"./bxp/logo.svg": "6dc7",
	"./cabcredit/logo.svg": "c0b8",
	"./cabcreditconta/logo.svg": "20f2",
	"./capitalcerto/logo.svg": "c49f",
	"./conquest_brazil/logo.svg": "04f8c",
	"./conta_pilas/logo.svg": "1ec7",
	"./contacheia/logo.svg": "df40",
	"./corredeira/logo.svg": "67de",
	"./credvale/logo.svg": "bc48",
	"./ctni/logo.svg": "a742",
	"./daniele/logo.svg": "0e9a",
	"./deltacredito/logo.svg": "663b",
	"./dmx/logo.svg": "07b0",
	"./dorocapital/logo.svg": "e7ac",
	"./fatorialdigital/logo.svg": "721a",
	"./fazprime/logo.svg": "d0eb",
	"./flow/logo.svg": "8ce3",
	"./franchiinfinity/logo.svg": "c897",
	"./galopes/logo.svg": "0e05",
	"./gaveasul/logo.svg": "577e3",
	"./gelmar/logo.svg": "b572",
	"./gii_digital/logo.svg": "419d",
	"./grananet/logo.svg": "f0e7",
	"./hotinvest/logo.svg": "2056",
	"./incentiveplus/logo.svg": "73fa",
	"./indexah_capital/logo.svg": "f3ed",
	"./infocapital/logo.svg": "c59c",
	"./innercapital/logo.svg": "54af",
	"./intra/logo.svg": "d072",
	"./jpacred/logo.svg": "11e8",
	"./k2fidc/logo.svg": "b78a",
	"./lafontte/logo.svg": "e3bc",
	"./laraescrow/logo.svg": "fbfc",
	"./leveldigital/logo.svg": "8700",
	"./libexcapital/logo.svg": "1584",
	"./moka/logo.svg": "529f",
	"./mosaicopay/logo.svg": "ff24",
	"./multiplica/logo.svg": "c3b8",
	"./nasapay/logo.svg": "f67b",
	"./nexepay/logo.svg": "789c",
	"./nfnucleo/logo.svg": "d513",
	"./nitrodigital/logo.svg": "9645",
	"./nrb/logo.svg": "cb38",
	"./onboarding/logo.svg": "b1c2",
	"./onboarding_conta_pilas/logo.svg": "c000",
	"./onboarding_corredeira/logo.svg": "db75",
	"./onboarding_ctni/logo.svg": "7177",
	"./onboarding_oro/logo.svg": "243b",
	"./onboarding_petrasolucoes/logo.svg": "b6ac",
	"./one7/logo.svg": "e1ee",
	"./opnexus/logo.svg": "709b",
	"./orooficial/logo.svg": "b6c3",
	"./oxigenio/logo.svg": "730d",
	"./pagway/logo.svg": "690f",
	"./petrasolucoes/logo.svg": "0604",
	"./prospera/logo.svg": "cb20",
	"./qprof/logo.svg": "696f",
	"./sifrabank/logo.svg": "10aa",
	"./trevys/logo.svg": "e073",
	"./ultradigital/logo.svg": "d186",
	"./viainvest/logo.svg": "0d5d",
	"./vrxservicos/logo.svg": "f445",
	"./werthub/logo.svg": "7038",
	"./wfcapital/logo.svg": "9ff2",
	"./whhold/logo.svg": "953b",
	"./yaaleh/logo.svg": "3acc",
	"./ybkdigital/logo.svg": "077f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e68";